import { Grid } from '@/react-pages/Prices/Grid';
import { Navigation } from '@/react-pages/Prices/Navigation';
import { Legend } from '@/react-pages/Prices/Legend';
import { Messages } from '@/react-pages/Prices/Messages';
import { RoomSelector } from '@/react-pages/Prices/RoomSelector';
import { TransportSelector } from '@/react-pages/Prices/TransportSelector';
import { PriceBasket } from '@/react-pages/Prices/PriceBasket';
import { useGridTabsContext } from '@/react-pages/Prices/GridTabsContext';
import { usePrices, useScrollToSection } from '@/domain/prices/prices/hooks';
import { AlternativeFilters } from './AlternativeFilters/AlternativeFilters';
import { usePriceFilters } from '@/domain/prices/filters/hooks';
import { UnavailableContentDialog } from '@sunwebgroup/ui-components';
import { useIntl } from '@/intl';
import { usePriceTableState } from '@/domain/prices/hooks';
import { useFlightSelectorQuery } from '@/domain/prices/transports/hooks';

export function PriceConfigurator() {
  const intl = useIntl();
  const { selectedTab } = useGridTabsContext();
  const { isEmptyResponse, isError } = usePriceFilters();
  const { alternativeFilters } = usePrices();
  const { isLoading } = usePriceTableState();
  const { isFetching } = useFlightSelectorQuery();

  useScrollToSection(isLoading, 'RoomSelector');
  useScrollToSection(isFetching, 'FlightSelector');

  if (selectedTab === 'alertService' || isError) return null;

  if (isEmptyResponse) {
    return (
      <UnavailableContentDialog
        title={intl.formatMessage({ id: 'prices_filters_no-results_title' })}
        message={intl.formatMessage({ id: 'prices_filters_no-results_message' })}
      />
    );
  }

  return (
    <>
      {alternativeFilters ? (
        <AlternativeFilters />
      ) : (
        <>
          <Messages />
          <Navigation />
          <Grid />
          <Legend />
          <RoomSelector />
          <TransportSelector />
          <PriceBasket />
        </>
      )}
    </>
  );
}
